import { Check, Close } from "@mui/icons-material";
import { Button } from "@mui/material";

const PlayFooter = ({
  handleWrong,
  handleCorrect,
  mobileView,
  cardIndex,
  totalCards,
  card,
  loading,
}) => {
  return (
    <div className="cta-buttons">
      <>
        {!mobileView ? (
          <Button
            color="ghostRed"
            variant="contained"
            disableElevation
            disabled={loading}
            className="py-2 px-4"
            onClick={() => handleWrong(card.id)}
            startIcon={<Close sx={{ fontSize: "1.7rem" }} />}
          >
            Incorrect
          </Button>
        ) : (
          <Button
            color="ghostRed"
            variant="contained"
            disableElevation
            disabled={loading}
            className="py-2"
            onClick={() => handleWrong(card.id)}
          >
            <Close sx={{ fontSize: "large" }} />
          </Button>
        )}
        <p className="mb-0 card-count">
          {loading ? "Loading ..." : `${cardIndex} of ${totalCards}`}
        </p>
        {!mobileView ? (
          <Button
            disabled={loading}
            color="ghostGreen"
            variant="contained"
            disableElevation
            className="py-2 px-4"
            onClick={() => handleCorrect(card.id)}
            startIcon={<Check sx={{ fontSize: "1.7rem" }} />}
          >
            Correct
          </Button>
        ) : (
          <Button
            color="ghostGreen"
            variant="contained"
            disabled={loading}
            disableElevation
            className="py-2"
            onClick={() => handleCorrect(card.id)}
          >
            <Check sx={{ fontSize: "large" }} />
          </Button>
        )}
      </>
    </div>
  );
};

export default PlayFooter;
